<template>
    <div class="w-full h-full">
        <Header title="Bank connections" icon="Landmark" />

        <!--<WhiteBox title="Search for an end user" subText="Find a users cashback object">
            <template v-slot:content>
                <div class="flex w-full justify-left items-center text-center gap-3 mb-2 item-center">
                    <CustomInput class="w-full" v-model="userSearch.publisher" type="text" placeholder="Publisher id" />
                    <CustomInput class="w-full" v-model="userSearch.userId" type="text" placeholder="User id" />
                    <CustomButton class="w-32" id="viewPublisherButton" text="Search" icon="Search" type="action"
                        @click="getConnectionsForAnEndUser(0, 50, userSearch)" />
                </div>
            </template>
        </WhiteBox>-->

        <WhiteBox title="Bank connections" subText="View the status of open banking connections">
            <template v-slot:buttons>
            </template>

            <template v-slot:content>
                <div class="grid grid-cols-1 xl:grid-cols-2 gap-x-2 mt-6">
                    <SearchBar placeholderText="Search by connection id" @search="(val) => getConnectionFromId(val)">
                        <CustomButton small text="" type="default" icon="X" @click="getConnections(0, 50)" />
                    </SearchBar>
                    <SearchBar placeholderText="Search by user id" @search="(val) => getConnectionsForAnEndUser(0,25,val)">
                        <CustomButton small text="" type="default" icon="X" @click="getConnections(0, 50)" />
                    </SearchBar>
                </div>
                <EasyDataTable :headers="headersTable1" :items="bankConnections" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="false"
                    :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #item-id="bankConnections">
                        <div class="w-32 py-1">
                                <p style="word-break:break-all; font-size:11px;">{{ bankConnections.id }}</p>
                        </div>
                    </template>
                    <template #item-endUserId="bankConnections">
                        <div class="w-32 py-1">
                                <p style="word-break:break-all; font-size:11px;">{{ bankConnections.endUserId }}</p>
                        </div>
                    </template>
                    <template #item-bank="bankConnections">
                        <div class="w-36 py-1">
                            <LogoAndText 
                            :logo="bankConnections.accountLogo"
                            :text="bankConnections.accountName"
                            />       
                        </div>
                    </template>
                    <template #item-isactive="bankConnections">
                        <div class="w-36">
                            <StatusPill
                                v-if="bankConnections.isActive"
                                text="LIVE"
                                colour="green"
                            />
                            <StatusPill
                                v-else
                                text="EXPIRED"
                                colour="red"
                            />
                        </div>
                    </template>
                    <template #item-created="bankConnections">
                        <div class="w-40 py-1">
                                <p style="font-size:11px;">{{ niceDateTime(bankConnections.created) }}</p>
                        </div>
                    </template>
                    <template #item-lastAccessed="bankConnections">
                        <div class="w-40 py-1">
                                <p style="font-size:11px;">{{ niceDateTime(bankConnections.lastAccessed) }}</p>
                        </div>
                    </template>
                    <template #header-disconnect="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-disconnect="bankConnections">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton
                                v-if="bankConnections.isActive"
                                small
                                text="End connection"
                                type="warning"
                                icon="X"
                                :requiresConfirmation="true"
                                confrimationModalTitle="End bank connection"
                                confrimationModalMessage="Confirm you would like to end this user's open banking bank account connection. This action will immediately prevent the user from earning cashback rewards via this connection."
                                confrimationModalButtonText="End connection"
                                @confirmClick="deleteConnection(bankConnections.id)"
                            />
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import SearchBar from '@/components/SearchBar.vue';
//import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import LogoAndText from "@/components/LogoAndText.vue";
import StatusPill from "@/components/StatusPill.vue";
import { DateTime } from 'luxon';



export default {
    name: "manage-publsihers",
    components: {
        Header,
        WhiteBox,
        SearchBar,
        //CustomInput,
        CustomButton,
        LogoAndText,
        StatusPill
    },
    props: {
    },

    data() {
        return {

            lastRequest: "ALL", // ALL / USER / ID

            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,



            userSearch: {
                publisher: "",
                userId: ""
            },

            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            loading: true,
            headersTable1: [
                { text: "Id", value: "connectionId" },
                { text: "Account Id", value: "accountId" },
                { text: "User id", value: "endUserId" },
                { text: "Bank", value: "bank" },
                { text: "Connection status", value: "isActive" },
                { text: "Created", value: "created" },
                { text: "Last accessed", value: "lastAccessed" },
                { text: "Disconnect", value: "disconnect" },
            ],
            bankConnections: [

            ],
        }
    },
    created() {
        this.getConnections(0, 50)

    },
    methods: {

        niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
		},

        async getConnectionsForAnEndUser(page, size, search) {
            try {
                this.lastRequest = "ALL"
                const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.bankConnections = []


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/account-requisition/user/${search}?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.bankConnections = object.content
                    this.serverItemsLength = object.totalElements  
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

        async getConnectionFromId(search) {
            try {
                const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true
                this.bankConnections = []



                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/account-requisition/requisition/${search}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()

                    this.bankConnections = object
                    this.serverItemsLength = object.length  
                    this.loading = false
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

        async deleteConnection(search) {
            try {
                const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true
                this.bankConnections = []



                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/account-requisition/requisition/${search}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.getConnections(0,25)
                }

            } catch (error) {
                return;
            }

        },

        async getConnections(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.lastRequest = "ALL"
                this.bankConnections = []

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/account-requisition?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.bankConnections = object.content
                    this.serverItemsLength = object.totalElements  
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

    },
    computed: {

    },
    mounted() {
        document.title = "Dashboard | Bank connections";
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val){

                    if(this.lastRequest == "ALL")
                        this.getConnections(val.page-1,val.rowsPerPage)
                    if(this.lastRequest == "USER")
                        this.getConnectionsForAnEndUser(val.page-1,val.rowsPerPage,this.userSearch)
                }
    }
    }
}
</script>